var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.93282f02fc20144c1ef0eff6b5f64c44.svg#B';
                    var viewUrl = 'sprites.93282f02fc20144c1ef0eff6b5f64c44.svg#view-B';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 23',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };